import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var fieldBox = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1hdvyao4',variantClassNames:{size:{small:'fx_2d2fb1e5_1hdvyao5','default':'fx_2d2fb1e5_1hdvyao6'},variant:{outline:'fx_2d2fb1e5_1hdvyao7',solid:'fx_2d2fb1e5_1hdvyao8'},state:{'default':'fx_2d2fb1e5_1hdvyao9',error:'fx_2d2fb1e5_1hdvyaoa'}},defaultVariants:{size:'default',state:'default',variant:'solid'},compoundVariants:[]});

export { fieldBox };
//# sourceMappingURL=fieldBox.vanilla.mjs.map
